import React from 'react'
import { Link } from 'react-router-dom'

export default function MissionAchievements() {
    return (
        <>
            <div className="main">
                <div className='page-head'>
                    <div className="container text-center">
                        <nav>
                            <ol className="breadcrumb mb-2 justify-content-center">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Mission & Achievements</li>
                            </ol>
                        </nav>
                        <h1>Mission & Achievements</h1>
                    </div>
                </div>
                <section className='section bg-white'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <img src="assets/images/mission.jpg" className='img-width-100' />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6">
                                <h3 className='main-title'>Our Mission</h3>
                                <p>Our mission is to enable our customers across the globe, with precision products & solutions that integrate leading edge innovation, technology, and multi-disciplinary engineering to make the world a better place.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='section'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <img src="assets/images/achievements.jpg" className='img-width-100' />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6">
                                <h3 className='main-title'>Our Achievements</h3>
                                <div className='info-list'>
                                    <ul>
                                        <li>More then 1000 successful installation across the globe</li>
                                        <li>Growth rate around 15% every year</li>
                                        <li>Production capacity 70 to 100 machines per annum</li>
                                        <li>Largest centreless & cylindrical grinding range in India</li>
                                        <li>Maximum customization</li>
                                        <li>All automation solutions under one roof</li>
                                        <li>Customized inspection system for in-process and post process</li>
                                        <li>75%+ repeat customer base makes us unique</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
